import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {ModalController, ToastController} from "@ionic/angular";
import {Auth} from "aws-amplify";

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
    public passwordForm: UntypedFormGroup;
    public oldPassword = "";
    public password = "";
    public newPassword = "";


    constructor(public fb: UntypedFormBuilder,
                public toastController: ToastController,
                public modalController: ModalController) {
        this.passwordForm = this.fb.group({
            'oldPassword': [''],
            'password': [''],
            'newPassword': ['']
        });
    }

    ngOnInit() {
    }

    async chacngePassword() {
        
        if (this.oldPassword == "" || this.password == "" || this.newPassword == "") {
            const toast = await this.toastController.create({
                message: "tutti i campi sono obbligatori",
                duration: 3000,
                position: "bottom",
                color: "danger"

            });
            await toast.present();
            return;
        }
        if (this.password != this.newPassword) {
            const toast = await this.toastController.create({
                message: "Le password non coincidono",
                duration: 1000,
                position: "bottom",
                color: "danger"

            });
            await toast.present();
            return;
        }
        try {
            let currentUser = await Auth.currentAuthenticatedUser();
            let change = await Auth.changePassword(currentUser, this.oldPassword, this.password);
            const toast = await this.toastController.create({
                message: "Password aggiornata con successo!",
                duration: 1000,
                position: "bottom",
                color: "success"

            });
            await toast.present();
        } catch (e) {
            if (e.toString().startsWith('InvalidPasswordException: Password did not conform')) {
                const toast = await this.toastController.create({
                    message: "Le password deve essere lunga al meno 8 caratteri",
                    duration: 1000,
                    position: "bottom",
                    color: "danger"

                });
                await toast.present();
            }else {
                const toast = await this.toastController.create({
                    message: "Vecchia password sbagliata",
                    duration: 1000,
                    position: "bottom",
                    color: "danger"

                });
                await toast.present();
            }
            
        }
        return;

    }
}
